import { setAlpha } from '../../design-tokens';
import { renderInlineCssVars, DesignTokens } from '../../theme';

// DND Style Tokens
// ref: http://designsystem-snapshot.sas.com/latest/components/drag-and-drop/styling/

export const getDndStyleTokens = (dt: DesignTokens) =>
  renderInlineCssVars(
    dt.enableNovaTokens
      ? {
          'item-medium-sh': dt.backgroundsDepthNova.medium.sh,
          'item-trans-dur': dt.animation.duration.exit.l,
          'item-anim-dur': dt.animation.duration.enter.l,
          'moved-item-opacity': 0.3,
          'drag-image-bg': dt.backgroundsDepthNova.standard.bg,
          'copied-item': dt.c.colorSecondary,
          'drop-line-bg': dt.c.colorPrimary,
          'drop-line-loop': dt.c.colorTextInverse,
          'drop-line-loop-shadow': setAlpha(dt.c.colorPrimary, 0.8),
          'drop-zone-bd': dt.c.colorPrimary,
          'drop-zone-bg': setAlpha(dt.c.colorPrimary, 0.1),
        }
      : {
          'item-medium-sh': dt.backgroundsDepth.medium.sh,
          'item-trans-dur': dt.animation.duration.exit.l,
          'item-anim-dur': dt.animation.duration.enter.l,
          'moved-item-opacity': 0.3,
          'drag-image-bg': dt.backgroundsDepth.standard.bg,
          'copied-item': dt.c.secondary,
          'drop-line-bg': dt.c.primary,
          'drop-line-loop': dt.c.white,
          'drop-line-loop-shadow': setAlpha(dt.c.primary, 0.8),
          'drop-zone-bd': dt.c.primary,
          'drop-zone-bg': setAlpha(dt.c.primary, 0.1),
        },
    'dnd'
  );
